import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { JobComponent } from './job.component';

const routes: Routes = [
  { path: '', component: JobComponent, data: { title: 'Job', reuseRoute: false } },
  { path: ':id', component: JobComponent, data: { title: 'Job', reuseRoute: false } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobRoutingModule {}

@NgModule({
  imports: [
    JobRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [JobComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JobModule {}
